import sendSentryError from "./sendSentryError";

export default async (survey, isCompleted, generateDocuments, responseUrl) => {
  const data = { ...(survey.data || {}) };
  data.pageNo = survey.currentPageNo;
  // Persist the *visible* SurveyJS page list so the server-rendered TopStepper can render
  // the same steps as `survey.visiblePages` (which may differ from `survey.pages` due to visibility rules).
  // Namespaced to avoid colliding with real Survey question keys.
  data.__bare = { ...(data.__bare || {}) };
  data.__bare.visiblePageNames = (survey.visiblePages || []).map((p) => p.name);
  // Also persist indices to safely reconstruct visible pages even when a page has a blank/undefined name.
  // NOTE: indices are 0-based in the `survey.pages` array and match SurveyJS ordering.
  data.__bare.visiblePageIndices = (survey.visiblePages || [])
    .map((p) => (survey.pages || []).indexOf(p))
    .filter((idx) => Number.isFinite(idx) && idx >= 0);
  try {
    await sendDataToServer(data, isCompleted, generateDocuments, responseUrl);
  } catch (error) {
    console.error(error);
  }
};

async function sendDataToServer(json, isCompleted, generateDocuments, responseUrl) {
  return new Promise((resolve, reject) => {
    const formData = createFormData(json, isCompleted, generateDocuments);
    // const url = document.getElementById("surveyContainer").getAttribute("data-response-url");
    const request = new XMLHttpRequest();

    request.onreadystatechange = function () {
      if (request.readyState === 4) {
        if (request.status === 200 || request.status === 204) {
          resolve();
        } else if (isCompleted) {
          sendSentryError(
            `Server failed to save request. HTTP Code: ${request.status}. Status Text: ${request.statusText}. URL: ${responseUrl}`
          );
          showAlert();
          reject(new Error("Failed to save survey data."));
        }
      }
    };

    try {
      sendRequest(request, responseUrl, formData);
    } catch (err) {
      sendSentryError(`Server can't be contacted. Error: ${err}. URL: ${responseUrl}`);
      showAlert();
      reject(err);
    }
  });
}

function createFormData(json, isCompleted, generateDocuments) {
  const formData = new FormData();
  formData.append("payload", JSON.stringify(json));
  formData.append("isCompleted", isCompleted);
  formData.append("generateDocuments", generateDocuments);
  return formData;
}

function sendRequest(request, url, formData) {
  request.open("POST", url);
  request.setRequestHeader(
    "X-CSRF-Token",
    document.querySelector("meta[name=csrf-token]")?.content
  );
  request.send(formData);
}

function showAlert() {
  alert(
    "Something went wrong while saving your data. Please try again later, or ask your arranger to save your data."
  );
  window.location.reload();
}
